<template>
  <v-card class="pa-6">
    <v-card-text>
      <p class="pa-3 mb-0">
        You have unsaved changes.
      </p>
    </v-card-text>

    <v-card-actions>
      <v-btn
        outlined
        color="coolgray"
        @click.stop="submitNetworkForm('Saved')"
      >
        Save
      </v-btn>

      <v-btn
        outlined
        color="primary"
        @click.stop="cancelForm"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import NetworkMixin from 'src/network/store/utils/networks-mixin'

export default {
  name: 'NetworkCancel',
  mixins: [
    NetworkMixin,
  ],
}
</script>
